import { render, staticRenderFns } from "./TransactionWidget.vue?vue&type=template&id=3bd4daee&scoped=true"
import script from "./TransactionWidget.vue?vue&type=script&lang=js"
export * from "./TransactionWidget.vue?vue&type=script&lang=js"
import style0 from "./TransactionWidget.vue?vue&type=style&index=0&id=3bd4daee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd4daee",
  null
  
)

export default component.exports